import { IState } from 'legacy/lut/store'

export const selectBusinessPrioritiesState = (state: IState) => state.partner360.businessPriorities
